export default __webpack_public_path__ + "static/media/test.1b6f02dc.jpg";